// 固定文字集中管理（§17）。元件只引用 key，不得寫死字面字串。
//
// 【證據等級】§7 第 3 級（原始碼）。每一則都逐字取自原系統原始碼並附出處行號，
// 但未經實機畫面確認 —— 原始碼寫什麼 ≠ 畫面顯示什麼。【雛形值待實機校準】
//
// ponytail: 扁平物件 + 直接索引，不引 i18n 函式庫 —— 本次只做 zh-TW（§17），
// 複數、語系切換全部用不到。升級路徑：真要多語系時再換 i18next。

export const messages = {
  // ── 動作 ────────────────────────────────────────────────
  'action.search': '查詢',
  'action.reset': '清除',
  'action.add': '新增',
  'action.edit': '修改',
  'action.delete': '刪除',
  // FC-5 R3（C1-c″）：「啟用/停用」狀態切換鈕的通用文案——原系統很多清單頁本來就有這顆鈕
  // （STATUS_ENABLED 欄位池 `['啟用','停用']`），雛形之前沒做，本批補上。這兩個字本身
  // 就是狀態值（STATUS_ENABLED），不是雛形新增字。
  'action.enable': '啟用',
  'action.disable': '停用',
  'action.save': '儲存',
  'action.cancel': '取消',
  'action.close': '關閉',
  /** sysConfirm 的確定鈕。common.js:366 */
  'action.confirm': '確定',
  /** showInfoDialog / showAlertDialog 的確認鈕。common.js:319,349 —— 與上面的「確定」是不同字，不可合併。 */
  'action.acknowledge': '確認',
  // FC-5 R2（C8）：R1 沒有來源註解，被驗證者點名「無出處」。已找到出處：DataTables
  // Buttons 擴充套件的 Excel 匯出鈕（class="buttons-html5"），raw DOM 逐字確認
  // `.tmp/ui/raw-dom/legacy/admin/config/config-device.html`／`config-annual.html`
  // 都是 `<a class="…buttons-html5" href="#"><span>Excel</span></a>`——legacy 原文
  // 逐字是「Excel」，不是「匯出Excel」。現值是雛形加了「匯出」前綴的意譯（不逐字），
  // 這屬於 actions 維度（不是本批 texts 窄集合），改不改成逐字「Excel」不屬本批範圍，
  // 不擅自改，留給控制者裁決。
  'action.export': '匯出Excel',
  /** layout/navbar.jsp:100-101 */
  'action.logout': '登出',
  /** form/printForms.jsp:33 window.print() */
  'action.print': '列印',
  /** 原系統沒有錯誤畫面（errorContent.jsp 只跳 alert），因此也沒有「重試」這個字。
   *  這是雛形為了讓錯誤可回復而新增的，**不是**原系統文案。 */
  'action.retry': '重試',
  /** batch 0：原系統沒有這顆鈕、沒有對應位置——雛形本身的展示／測試工具，
   *  把 localStorage 持久化的 CRUD 異動清回 fixtures 種子值。**不是**原系統文案。 */
  'action.resetTestData': '重置測試資料',

  /** WEB-INF/views/index.jsp:115 登入表單送出鈕 */
  'action.login': '登入',

  // ── 確認訊息（原系統 sysConfirm 的字面值）────────────────
  /** js-my/class/announcementModal.js:40、js-my/class/announcementTab.js:42、
   *  js-my/clazzList.js:2354 —— 同一句在三處出現，取半形問號版本。
   *  另有全形版「是否確定要刪除？」（clazzList.js:286,313），差異列為【雛形值待實機校準】。 */
  'confirm.delete': '是否確定要刪除?',
  /** js-my/instruction/courseDepartmentCode.js:48 */
  'confirm.save': '確定要儲存嗎？',
  // FC-5 R3：狀態切換鈕的通用退路文案（沒有 legacy 專屬訊息時才會顯示，屬【雛形新增】）。
  // 有 legacy 專屬訊息的頁面一律顯示 legacy 逐字原文（見 CrudListPage.tsx 的
  // resolveLegacyMessageForAction 呼叫），這兩個 key 只是保底——故意不抄任何 legacy 頁面
  // 的原文，抄了會讓擷取腳本在「沒有專屬訊息的頁面」上誤判成找到 legacy 那條專屬訊息
  // （C5-b 假訊息率要防的事）。
  'confirm.enable': '確定要把這個項目改成啟用狀態嗎？',
  'confirm.disable': '確定要把這個項目改成停用狀態嗎？',
  /** batch 0：重置測試資料鈕的破壞性操作確認文案，**不是**原系統文案（同 action.retry 的性質）。 */
  'confirm.resetTestData': '確定要重置測試資料嗎？所有新增、修改、刪除的內容都會復原成預設值。',

  // ── 導覽 ────────────────────────────────────────────────
  /** layout/menu_general.jsp:18 */
  'nav.home': '首頁',
  /** layout/navbar.jsp:92 */
  'nav.switchRole': '切換身分',
  'role.student': '學員',
  'role.nonStudent': '非學員',
  /** layout/navbar.jsp:93 ${...? '(現在)':''} */
  'role.current': '(現在)',

  // ── DataTable chrome（來源全部是 js-my/common.js 的 language 物件）──
  /** common.js:806 —— 原系統含尾端冒號，照實保留。 */
  'table.searchLabel': '關鍵字查詢:',
  /** common.js:800 */
  'table.lengthMenu': '顯示 {menu} 項結果',
  /** common.js:815 buttons.pageLength._ */
  'table.pageSizeOption': '每頁顯示 {size} 項結果',
  'table.pageSize': '每頁顯示',
  /** common.js:802 */
  'table.info': '顯示第 {start} 至 {end} 項結果，共 {total} 項',
  /** common.js:803 */
  'table.infoEmpty': '顯示第 0 至 0 項結果，共 0 項',
  /** common.js:804 */
  'table.infoFiltered': '(從 {max} 項結果中過濾)',
  /**
   * 空表文案。common.js:823 的 sZeroRecords。
   *
   * 同一個 language 物件裡另有 `zeroRecords: "沒有符合的結果"`（common.js:801），
   * 兩者衝突。實際生效的是**本則**，追溯過程：
   *   jquery.dataTables.min.js 版本 1.10.15
   *   :1854  J(l, $.extend(g, q.data()))   ← 第三參數省略，force 為 falsy
   *   :1841  Y() 建的 _hungarianMap 方向是 camel → Hungarian
   *   :28    if (d !== undefined && (force || b[d] === undefined))
   *          key `zeroRecords` 對到 `sZeroRecords`，而後者已有值 → 條件 false → 不覆寫
   * 故內部 oLanguage.sZeroRecords 維持「查無符合的資料」，與 AUDIT_GATE3 的稽核結論一致。
   * 【仍為原始碼推論，未實機確認】
   */
  'table.empty': '查無符合的資料',
  /** common.js:798 */
  'table.processing': '處理中...',
  /** common.js:799 */
  'table.loadingRecords': '載入中...',

  // ── 分頁（common.js:808-811）────────────────────────────
  'page.first': '第一頁',
  'page.previous': '上一頁',
  'page.next': '下一頁',
  'page.last': '最後一頁',

  // ── 對話框 ──────────────────────────────────────────────
  /** common.js:340 showAlertDialog(content, cb, title = "警告") */
  'dialog.alertTitle': '警告',
  /** common.js:331 showInfoDialog title: '訊息' */
  'dialog.infoTitle': '訊息',
  // 註：sysConfirm 沒有獨立標題（common.js:363 content:false，訊息本身就是標題），
  // 所以刻意沒有 dialog.confirmTitle 這個 key。

  // ── 狀態 ────────────────────────────────────────────────
  'state.loading': '載入中',
  /** training/studyRecord/errorContent.jsp:5 */
  'error.generic': 'Ooops! 程式發生錯誤！',
  // FC-5 R3：狀態切換失敗的通用退路文案（沒有 legacy 專屬訊息時才會顯示，屬【雛形新增】）。
  // 故意不抄任何 legacy 頁面的原文——這是保底文案，抄了反而會讓擷取腳本在「沒有專屬
  // 訊息的頁面」上誤判成「找到了」那條 legacy 專屬訊息（C5-b 假訊息率要防的事）。
  'error.enableFailed': '這個項目啟用失敗了，請稍後再試一次。',
  'error.disableFailed': '這個項目停用失敗了，請稍後再試一次。',

  // ── 無權限（FC-5 Q3 裁決：拆三個 key，逐字對齊 legacy 錯誤頁，不再是雛形新增字）──
  // 來源實測：`.tmp/ui/raw-dom/legacy/admin/home/main-dentisit-student-main.html` 的
  // `.error-template` 區塊（FORBIDDEN Access 錯誤殼，25 頁皆同一段文字，逐字相符）：
  //   <h1>Sorry! 很抱歉！</h1>
  //   <div class="error-details">FORBIDDEN Access 您無權限存取此頁面<br>這是防止CSRF攻擊的
  //   安全防護，請重新載入首頁再做登入。</div>
  // 舊版單一 key `state.unauthorized`＝「您沒有權限存取此功能」是雛形自己造的字，
  // legacy 實際文字不同（C5-b 曾經抓到的 1 條真缺陷），本批改為逐字採用 legacy 原文。
  'error.forbiddenTitle': 'Sorry! 很抱歉！',
  'error.forbiddenDetail': 'FORBIDDEN Access 您無權限存取此頁面',
  'error.forbiddenHint': '這是防止CSRF攻擊的安全防護，請重新載入首頁再做登入。',

  // ── 登入頁（WEB-INF/views/index.jsp）────────────────────
  /** WEB-INF/views/index.jsp:18 <title>。原系統畫面上的標題是 EL ${sysTitle}（:79），
   *  值由後端設定決定、原始碼看不到，因此改用同頁 <title> 的字面值。【雛形值待實機校準】 */
  'login.systemTitle': '臨床教育 e-Portfolio',
  /** WEB-INF/views/index.jsp:87 */
  'login.unit': '單位',
  /** WEB-INF/views/index.jsp:90 */
  'login.unitLdap': '外部AD登入',
  /** WEB-INF/views/index.jsp:91 */
  'login.unitLocal': '本機帳號',
  /** WEB-INF/views/index.jsp:97 */
  'login.account': '帳號',
  /** WEB-INF/views/index.jsp:100 placeholder */
  'login.accountPlaceholder': '請輸入您的帳號',
  /** WEB-INF/views/index.jsp:104 */
  'login.password': '密碼',
  /** WEB-INF/views/index.jsp:107 placeholder */
  'login.passwordPlaceholder': '請輸入您的密碼',
  /** WEB-INF/views/index.jsp:126 <small><strong>版權所有</strong> … &copy; 2019</small> */
  'login.copyright': '版權所有 勤紘科技 臨床教育訓練管理系統 © 2019',

  // ── 以下為【雛形新增】：原系統原始碼中查無對應字面值 ──────
  // 原系統的必填檢核靠 HTML5 required（例：WEB-INF/views/index.jsp:100,107），訊息由瀏覽器產生、
  // 隨瀏覽器語系不同，原始碼裡沒有這串字。
  'validation.required': '此欄位為必填',
  // 原系統存檔成功的提示文字由後端 response 的 desc 欄位帶回
  // （見 js-my/vote/excellentTeacher.js:208 showResponse(title, resp.desc)），
  // 前端原始碼中沒有固定字串可引用。
  'state.saveSuccess': '儲存成功',
  // 列表操作欄表頭。原系統多數列表的操作欄表頭是空的 <th>
  // （例：instruction/courseDepartmentCode.jsp:83），少數才寫「操作」（leave/leaveType.jsp:451）。
  // 雛形一律給文字，讓讀屏有欄位名稱可念。
  'table.actions': '操作',
  // 查詢表單的關鍵字欄位標籤。原系統 DataTables 的「關鍵字查詢:」（table.searchLabel）
  // 是表格內建搜尋框，與查詢表單欄位不是同一個東西，不共用同一個 key。
  'search.keyword': '關鍵字',
  // 複雜表單的區塊標題。
  'form.sectionMain': '基本資料',
  'form.sectionMore': '其他資料',
  // 匯出鈕。原系統是 DataTables buttons 的 excel 匯出（common.js:829-854），會真的下載檔案；
  // 雛形不產檔，用一則說明取代。
  'export.notice': '雛形不產生檔案，此按鈕僅示範匯出流程。',
  // redirect 頁型（NEW-UI-IMPLEMENTATION-CHECKLIST §5.2「redirect：不建 React 頁」）。
  'redirect.notice': '此頁在原系統只做轉址，不建立 React 畫面。',
  'redirect.target': '轉址目標',
  // unresolved 頁型：Gate 1 盤點未定案，需 S2-3 在原系統實跑觸達後才能判定。
  'unresolved.notice': '此頁分類未定，需 S2-3 在原系統實跑觸達後才能判定。',
  'unresolved.pageId': 'Page ID',
  'unresolved.legacyUrl': '原系統 URL',
  'unresolved.none': '（無）',

  // ── 無障礙用（原系統無對應可見文字，雛形新增）──────────
  'a11y.mainContent': '主要內容',
  'a11y.sidebarMenu': '功能選單',
  'a11y.pagination': '分頁',
  'a11y.toggleSidebar': '收合／展開選單',

  // ==== BEGIN GENERATED legacy.* ====
  // FC-5 R5（C5-b 修正）：這段以下由 `scripts/generate-zh-tw-legacy.ts` 從
  // `src/app/legacy-texts.generated.ts`（101 條可歸頁訊息的權威來源）機械產生，**不要手改**。
  // 重新產生：`./node_modules/.bin/tsx scripts/generate-zh-tw-legacy.ts`
  // ---- FC-5 legacy.global（逐字取自 legacy-texts.generated.ts，來源見各行註解）----
  'legacy.global.01': '下載檔案失敗！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:124
  'legacy.global.02': '是否確定要刪除檔案?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:1102
  'legacy.global.03': '未選擇上傳檔案!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/ePortfolio.js:839
  'legacy.global.04': '查無符合的資料', // [empty] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:823
  'legacy.global.05': '檔案上傳限制：僅支援以下副檔名<br>圖像格式：png、jpeg、jpg、bmp', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:1084
  'legacy.global.06': '檔案上傳限制：僅支援以下副檔名<br>文書格式：doc、docx、xls、xlsx、ppt、pptx、txt、pdf、odt、ods、odp<br>影音格式：ecm、mp4、mov、avi、wmv、mkv<br>圖像格式：png、jpeg、jpg、bmp', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:1071
  'legacy.global.07': '沒有符合的結果', // [empty] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:801
  'legacy.global.08': '警告', // [other] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/common.js:603
  // ---- FC-5 legacy.shared（逐字取自 legacy-texts.generated.ts，來源見各行註解）----
  'legacy.shared.01': 'OOOPS!!! 粉紅底色欄位輸入數字不可超過設定範圍!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFill.js:136
  'legacy.shared.02': 'OOOPS!!!<br>粉紅底色欄位為必塡，不可空白並要符合規定字數。', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFill.js:118
  'legacy.shared.03': '下載檔案失敗！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/classUtils.js:286
  'legacy.shared.04': '儲存失敗，請聯絡系統管理員', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/deptAdminMain.js:245
  'legacy.shared.05': '只能選擇1張表單!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:464
  'legacy.shared.06': '尚未存檔，是否確定要關閉?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/courseModal.js:46
  'legacy.shared.07': '已完成的表單不需要發送通知，請重新選擇!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:324
  'legacy.shared.08': '授課教師僅能為一名', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/clazzQueryList.js:1133
  'legacy.shared.09': '操作錯誤!您選到已經是停用狀態的表單!', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:250
  'legacy.shared.10': '操作錯誤!您選到已經是啟用狀態的表單!', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:245
  'legacy.shared.11': '是否確定要刪除?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/announcementModal.js:40
  'legacy.shared.12': '是否確定要刪除課程?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/clazzQueryList.js:361
  'legacy.shared.13': '是否確定要發表單給自己?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/courseFormTab.js:18
  'legacy.shared.14': '是否確定要發送填寫通知?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:332
  'legacy.shared.15': '是否確定要移除附件?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFill.js:171
  'legacy.shared.16': '是否確定要變更?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:29
  'legacy.shared.17': '是否確定要變更新歸屬者？', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:500
  'legacy.shared.18': '是否確定要變更表單為未完成?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:386
  'legacy.shared.19': '未選擇新填寫者!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:21
  'legacy.shared.20': '未選擇新歸屬者!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:493
  'legacy.shared.21': '未選擇是否要變更流程人員!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:497
  'legacy.shared.22': '未選擇表單!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:134
  'legacy.shared.23': '查不到資料!', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/classUtils.js:284
  'legacy.shared.24': '查詢失敗', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/mainUtils.js:525
  'legacy.shared.25': '查詢失敗，請聯絡系統管理員！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/deptAdminMain.js:337
  'legacy.shared.26': '此計畫尚未安排學員！', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/deptAdminMain.js:221
  'legacy.shared.27': '無異動人員！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/main/deptAdminMain.js:188
  'legacy.shared.28': '行事曆檢視日期不能跨月份!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/classUtils.js:326
  'legacy.shared.29': '請填寫公告內容', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/announcementModal.js:170
  'legacy.shared.30': '超過上課人數.', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/clazzQueryList.js:527
  'legacy.shared.31': '超過最大字數', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formComment.js:99
  'legacy.shared.32': '錯誤! 已完成的表單才能改為未完成!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:378
  'legacy.shared.33': '錯誤! 未選擇表單!', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formList.js:382
  'legacy.shared.34': '點名代碼長度不足6碼!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/class/clazzQueryList.js:246
  // ---- FC-5 legacy.unique（逐字取自 legacy-texts.generated.ts，來源見各行註解）----
  'legacy.unique.01': '下載失敗，請聯絡系統管理員', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:328
  'legacy.unique.02': '下載失敗，請聯絡系統管理員！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/instruction/courseDepartmentCode.js:38
  'legacy.unique.03': '下載檔案失敗！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/courseFormFinishrate.js:160
  'legacy.unique.04': '不可添加自己!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/coEditForm/formGenerator.js:147
  'legacy.unique.05': '主治醫師推薦名單超過2名！', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:116
  'legacy.unique.06': '住院醫師推薦名單超過2名！', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:121
  'legacy.unique.07': '停用失敗，請聯絡系統管理員！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:596
  'legacy.unique.08': '僅能上傳xlsx檔案！', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:175
  'legacy.unique.09': '儲存失敗，請聯絡系統管理員！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:461
  'legacy.unique.10': '刪除失敗，請聯絡系統管理員！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:621
  'legacy.unique.11': '刪除後無法復原，確定要刪除嗎?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:337
  'legacy.unique.12': '匯入失敗！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:425
  'legacy.unique.13': '啟用失敗，請聯絡系統管理員！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:646
  'legacy.unique.14': '必須選擇訓練類別!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/fieldTypeList.js:22
  'legacy.unique.15': '推薦失敗，請聯絡系統管理員！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:151
  'legacy.unique.16': '日期時間錯誤!', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:790
  'legacy.unique.17': '日期時間錯誤!!', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:794
  'legacy.unique.18': '日期選取不正確!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:222
  'legacy.unique.19': '是否確定要停用?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:358
  'legacy.unique.20': '是否確定要啟用?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:364
  'legacy.unique.21': '有必要欄位未填寫!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:755
  'legacy.unique.22': '有指定角色隱藏資料，請輸入去識別期間！', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFieldsConfig.js:58
  'legacy.unique.23': '有簽核流程欄位未填寫!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:801
  'legacy.unique.24': '未輸入去識別期間!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/fieldTypeList.js:92
  'legacy.unique.25': '未輸入名稱!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/fieldTypeList.js:85
  'legacy.unique.26': '本次投票活動沒有貴科部醫師名單，請洽教學室承辦人', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:44
  'legacy.unique.27': '查不到資料!', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/courseFormFinishrate.js:158
  'legacy.unique.28': '查無符合的資料', // [empty] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/indexCommon.js:196
  'legacy.unique.29': '查詢失敗，請聯絡系統管理員！', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/deptManagerRecommend.js:297
  'legacy.unique.30': '檔案上傳限制：僅支援以下副檔名<br>docx、jpg、pdf、png、doc', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:1177
  'legacy.unique.31': '沒有符合的結果', // [empty] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/indexCommon.js:174
  'legacy.unique.32': '確定要儲存嗎?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:34
  'legacy.unique.33': '確定要儲存嗎？', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/instruction/courseDepartmentCode.js:48
  'legacy.unique.34': '確定要刪除嗎？', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/instruction/courseDepartmentCode.js:68
  'legacy.unique.35': '確定要匯入嗎?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:178
  'legacy.unique.36': '確認刪除這筆請假單?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:1124
  'legacy.unique.37': '缺訓練科部!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:760
  'legacy.unique.38': '表單產生成功', // [success] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/coEditForm/formGenerator.js:217
  'legacy.unique.39': '說明文字最多100字元！', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/coEditForm/formGenerator.js:284
  'legacy.unique.40': '請先登入系統', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/index.js:21
  'legacy.unique.41': '請問是否要刪除?', // [confirm] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/coEditForm/queryPage.js:111
  'legacy.unique.42': '請於備註欄位填寫不同意原因!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/leaveForm.js:1000
  'legacy.unique.43': '請選擇使用範圍!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:296
  'legacy.unique.44': '請選擇共用角色!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:299
  'legacy.unique.45': '請選擇匯入檔案!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:168
  'legacy.unique.46': '請選擇匯入的投票!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/voteMaintenance.js:116
  'legacy.unique.47': '請選擇匯入的檔案', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:397
  'legacy.unique.48': '請選擇學年度', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:344
  'legacy.unique.49': '請選擇投票！', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/vote/totalVoteAnalysisReport.js:25
  'legacy.unique.50': '請選擇科部!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:288
  'legacy.unique.51': '請選擇結束時間!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/report/gpaFormReport.js:84
  'legacy.unique.52': '請選擇表單!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/report/gpaFormReport.js:66
  'legacy.unique.53': '請選擇訓練計畫!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/report/allStudentScores.js:67
  'legacy.unique.54': '請選擇訓練類別', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:227
  'legacy.unique.55': '請選擇部門', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:231
  'legacy.unique.56': '請選擇醫院', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/academicMOM.js:348
  'legacy.unique.57': '請選擇類別!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/comment.js:292
  'legacy.unique.58': '請選開始時間!', // [validation] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/report/gpaFormReport.js:79
  'legacy.unique.59': '讀檔失敗!', // [failure] ePortfolio_work/ePortfolio-tsgh/WebContent/js-my/formFieldsConfig.js:651
  // ==== END GENERATED legacy.* ====
} as const;

export type MessageKey = keyof typeof messages;

/** 取固定文字。`vars` 用來填 {name} 佔位符。 */
export function t(key: MessageKey, vars?: Record<string, string | number>): string {
  const raw: string = messages[key];
  if (!vars) return raw;
  return raw.replace(/\{(\w+)\}/g, (whole, name: string) => String(vars[name] ?? whole));
}
